module.exports = __webpack_public_path__ + "static/media/Nutriroyal.f397e17c.png";